<h2 class="sr-only" i18n="@@hermes.title.results-on-the-map">Results on the map</h2>
@if ((isDefinedSelectedLocation$ | async) === true) {
    <h-map-container
        [mapEvent$]="mapEvent$"
        [markers]="markers"
        [displayZoom]="(displayZoom$ | async) === true"
        [isMarkerClustererActive]="true"
        [isZoomOnClickActive]="(shopLocatorFacade.mode$ | async) === 'map'"
        [hasFullScreenButton]="(shopLocatorFacade.mode$ | async) === 'map'"
        [isInMobile]="(shopLocatorFacade.mode$ | async) === 'map-mobile'"
        (markersCoordinatesInBounds)="markersCoordinatesInBounds$.next($event)"
        (hoveredMarkerCoordinates)="hoveredMarkerCoordinates$.next($event)"
        (unhoveredMarkerCoordinates)="handleUnhoveredMarkerCoordinates()"
        (clickedMarkerCoordinates)="clickedMarkerCoordinates$.next($event)">
    </h-map-container>
}
